import React from "react";

const TableCaption = ({ captionName }) => {
  return <caption className="hidden-caption">{`${captionName} table`}</caption>;
};

export default TableCaption;
